<div class="fw-autocomplete" (mouseleave)="onMouseLeaveAutocomplete($event)">
  <div (click)="openDropdown()" (focusin)="openDropdownOnFocus()">
    <ng-content></ng-content>
  </div>
  <ng-template #dropdownTemplate>
    <div class="fw-autocomplete-list parent" [ngStyle]="{width, maxHeight}" *ngIf="showAutocomplete">
      <div *ngIf="!items; else data" class="fw-autocomplete-list-item loading">
        <fw-progress-spinner></fw-progress-spinner>
      </div>
      <ng-template #data>
        <ng-container *ngIf="items?.length;else noResults">
          <div [class.hovered]="currentHoveredItem?.field.value === item.field.value" (click)="selectItem(item.field)"
            class="fw-autocomplete-list-item data" *ngFor="let item of items; trackBy:trackAutocompleteItem"
            (mouseover)="onItemHover(item, $event)">
            <div class="fw-autocomplete-list-item-text">
              <div class="fw-autocomplete-list-item-text-name">{{ item.field.name }}</div>
              <div *ngIf="item.field.description" class="fw-autocomplete-list-item-text-description">
                {{ item.field.description }}</div>
            </div>
            <fw-icon *ngIf="item.subfields?.length" class="fw-autocomplete-list-item-icon" size="medium"
              color="muted">chevron-forward</fw-icon>
          </div>
        </ng-container>
        <ng-template #noResults>
          <div (click)="closeDropdown()" class="fw-autocomplete-list-item">
            <div class="fw-autocomplete-list-item-text">
              <div class="fw-autocomplete-list-item-text-name">{{ 'common.labels.noResults' | translate }}</div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #childDropdownTemplate>
    <div data-child-overlay="true" class="fw-autocomplete-list-wrapper">
      <div class="fw-autocomplete-list child" [ngStyle]="{width, maxHeight}"
        *ngIf="currentHoveredItem && currentHoveredItem.subfields" (mouseleave)="closeChildDropdown()">
        <div (mouseover)="onChildHover(child)" [class.hovered]="currentHoveredChildItem?.value === child.value"
          (click)="selectItem(child)" class="fw-autocomplete-list-item data" data-child-overlay-item="true"
          *ngFor="let child of currentHoveredItem.subfields; trackBy:trackAutocompleteField">
          <div class="fw-autocomplete-list-item-text">
            <div class="fw-autocomplete-list-item-text-name">{{ child.name }}</div>
            <div *ngIf="child.description" class="fw-autocomplete-list-item-text-description">{{ child.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
